import { combineReducers } from 'redux';

import userLoginStatus from './ReducerLoginStatus';
import isPc from './ReducerIsPc';
import showPlan from './ReducerIsPlan'
import showMineTips from './ReducerMineTips'

const rootReducer = combineReducers({
    userLoginStatus,
	// isPc,
	showPlan,
	showMineTips,
});

export default rootReducer;

